export const getTableToolbarText = (
  totalNumberOfItems: number,
  currentPage: number,
  itemsPerPage: number,
) => {
  if (totalNumberOfItems === 0) {
    return '';
  }

  const startItem = currentPage * itemsPerPage + 1;
  const endItem = Math.min((currentPage + 1) * itemsPerPage, totalNumberOfItems);

  return `Showing ${startItem}-${endItem} of ${totalNumberOfItems} Employees`;
};

export const getGenderText = (gender: 'm' | 'f' | 'o' | null) => {
  if (gender === 'm') {
    return 'Male';
  }
  if (gender === 'f') {
    return 'Female';
  }
  if (gender === 'o') {
    return 'Other';
  }
  return gender;
};
